import { STATUS_TYPE } from "taltech-styleguide";
import { ErrorScreenProps , ErrorScreen} from "./ErrorScreen";

const Error403Screen: React.FC<any> = () => {
  const props: ErrorScreenProps = {
    variant: STATUS_TYPE.DANGER,
    status: 403,
    title: "Forbiden",
    message: "You don't have the necessary permission to access this resource",
  };
  return <ErrorScreen {...props} />;
};

export {Error403Screen};
